/* esm.sh - d3-transition@3.0.1/src/transition/styleTween */
export * from "/*d3-transition@3.0.1/esnext/src/transition/styleTween.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/styleTween.mjs";
